var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "expand_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m11.62 18.71 6.11-6.05a1 1 0 0 0 .3-.71 1 1 0 0 0-.3-.71l-6.08-5.95a.987.987 0 0 0-1.41.02c-.39.4-.38 1.03.02 1.41l4.32 4.23H3c-.55 0-1 .45-1 1s.45 1 1 1h11.6l-4.39 4.34a.99.99 0 0 0-.01 1.41c.39.39 1.02.4 1.41 0zM21.56 18.5c0 .55-.44 1-1 1-.55 0-1-.44-1-1v-13c0-.55.44-1 1-1 .55 0 1 .44 1 1z"
})));
export default SvgExpand;